import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import AppVersionSnackbar from './ui-component/AppVersionSnackbar';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
// ==============================|| APP ||============================== //

const App = () => {
    const customization = useSelector((state) => state.customization);

    return (
        <StyledEngineProvider injectFirst>
            <AuthProvider>
                <ThemeProvider theme={themes(customization)}>
                    <CssBaseline />
                    <NavigationScroll>
                        <Routes />
                        <AppVersionSnackbar />
                    </NavigationScroll>
                </ThemeProvider>
            </AuthProvider>
        </StyledEngineProvider>
    );
};

export default App;
